import axios from 'axios'


//eslint-disable-next-line
async function sleep(t) {
    return new Promise(resolve=>setTimeout(resolve, t*1000));
}

export const uploadInsuranceForm = async (formData) => {    
    return (await axios.post('/insurance/quickRegister', formData)).data
}

export const getInsuranceDoc = async (id) => {
    if (!id) {
        throw new Error('Record ID cannot be empty.')
    }
    return (await axios.get(`/insurance/insuranceRecord/${id}`)).data
}

export const getInsuranceDocBy = async ({id, by}) => {
    if (!id) {
        throw new Error('Record ID cannot be empty.')
    }
    
    switch (by) {
        case 'aptitudeId':
        case 'orderId':
            return (await axios.get(`/insurance/getInsuranceRecordById/?id=${id}&by=${by}`)).data
        default:
            return (await axios.get(`/insurance/insuranceRecord/${id}`)).data
    }
    
}

export const createInsuranceRecord = async (formData) => {
    return (await axios.post('/insurance/insuranceRecord', formData)).data
}

export const removeUserInsurance = async (id) => {
    // await sleep(2)
    // return 'ok'
    return (await axios.delete(`/insurance/removeUserInsurance/${id}`)).data
}

export const updateInsuranceForm = async ({formData,id}) => {
    if (!id) {
        throw new Error('Record ID cannot be empty.')
    }
    return (await axios.put(`/insurance/insuranceRecord/${id}`,formData)).data
}